import { createAction, props } from "@ngrx/store";
import { Constants } from "app/core/data/constants";
import { ToggleObjectModel } from "app/core/models/toggle-object.model";


export const setUpsertMissionForm = createAction(Constants.SET_UPSERT_MISSION_FORM,props<{upsertMissionForm:any}>());
export const setCandidatesListForUpsertMission = createAction(Constants.SET_CANDIDATES_LIST_MISSION_FORM,props<{candidatesListForUpsertMission:any[]}>());
export const toggleCandidate = createAction(Constants.TOGGLE_CANDIDATE,props<{toggledList:ToggleObjectModel[]}>());
